// Anamnese-Dialog — extrahiert aus AppointmentsPage.js.
import React from 'react';
import { FileText } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import CustomerAnamnese from '@/components/CustomerAnamnese';

export const AnamneseDialog = ({ open, onOpenChange, customer, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5" />
          Anamnese - {customer?.first_name} {customer?.last_name}
        </DialogTitle>
      </DialogHeader>
      {customer && (
        <CustomerAnamnese
          customerId={customer.id}
          customerName={`${customer.first_name} ${customer.last_name}`}
          onSave={onSave}
        />
      )}
    </DialogContent>
  </Dialog>
);
